import * as LocalStorage from 'services/storage/LocalStorage';
import { LocalStorageKey } from 'services/storage/LocalStorage';
import { parseJwt } from 'utils/jwt';

type JWTsObject = {
  idToken?: string;
  accessToken?: string;
  refreshToken?: string;
};

export const getJWTAuthBearer = (): string => {
  const accessToken = LocalStorage.get('accessToken');
  const idToken = LocalStorage.get('idToken');
  const refreshToken = LocalStorage.get('refreshToken');
  return `id_token=${idToken},access_token=${accessToken},refresh_token=${refreshToken}`;
};

export const storeJWTs = (JWTs: JWTsObject) => {
  Object.entries(JWTs).forEach(([tokenKey, tokenValue]) => {
    if (!tokenValue || tokenValue === 'undefined') return;
    LocalStorage.set(tokenKey as LocalStorageKey, tokenValue);
  });
};

export const removeJWTs = () => {
  LocalStorage.remove('idToken');
  LocalStorage.remove('accessToken');
  LocalStorage.remove('refreshToken');
};

type CognitoAttribute = 'email' | 'subTier';

export const getCognitoAttribute = (attribute: CognitoAttribute) => {
  const idToken = LocalStorage.get('idToken');
  if (!idToken) return undefined;

  try {
    const parsedToken = parseJwt(idToken);
    switch (attribute) {
      case 'email': {
        const email = parsedToken?.email;
        return typeof email === 'string' ? email : undefined;
      }
      case 'subTier': {
        const subTier = parsedToken['custom:subscription_tier'];
        return typeof subTier === 'string' ? subTier : undefined;
      }
      default:
        return undefined;
    }
  } catch {
    return undefined;
  }
};
